var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8369 0 32 7.16313 32 16C32 24.8369 24.8369 32 16 32C7.16313 32 0 24.8369 0 16C0 7.16313 7.16313 0 16 0ZM23.6931 11.0706C23.2006 11.2938 22.6588 11.4288 22.1269 11.5181C22.595 11.4394 23.2875 10.3225 23.4212 9.88437C23.4619 9.80437 23.4037 9.77625 23.335 9.81C22.7419 10.1281 22.1281 10.3588 21.475 10.5219C21.3525 10.5525 21.2794 10.4 21.1844 10.3212C18.8663 8.34937 15.4169 10.3269 15.8675 13.3819C15.8775 13.4569 15.8706 13.4669 15.8031 13.4569C13.2488 13.0763 11.1306 12.1625 9.41187 10.2031C9.33687 10.1181 9.29625 10.1181 9.23563 10.21C8.33063 11.5662 8.98375 13.4519 10.1806 14.385C10.13 14.395 9.50438 14.3275 8.9475 14.0394C8.8725 13.9919 8.835 14.0194 8.82875 14.1038C8.75312 15.4313 9.9625 16.9825 11.2788 17.2081C11.0319 17.2619 10.7775 17.3013 10.0688 17.2456C9.98063 17.2288 9.94688 17.2725 9.98063 17.3575C10.5131 18.8081 11.6619 19.24 12.5225 19.4856C12.6375 19.5056 12.7531 19.5056 12.8687 19.5331C12.24 20.4675 9.52187 20.9137 8.47625 20.8106C8.40375 20.8 8.13125 20.7619 8.30688 20.9056C14.5169 25 22.2512 20.6181 22.2512 12.83C22.2512 12.7294 22.37 12.6744 22.4406 12.6213C22.7638 12.3781 23.7512 11.4875 23.7512 11.0706C23.7512 11.0294 23.7563 11.0425 23.6931 11.0706Z",
    fill: "#6E7E9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.27883b52354b6f4194fa37753284d52a.svg";
export { ForwardRef as ReactComponent };